import { render, staticRenderFns } from "./JurusanDetail.vue?vue&type=template&id=e0a829c6&scoped=true&"
import script from "./JurusanDetail.vue?vue&type=script&lang=js&"
export * from "./JurusanDetail.vue?vue&type=script&lang=js&"
import style0 from "./JurusanDetail.vue?vue&type=style&index=0&id=e0a829c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a829c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VContainer})
